import React from 'react'
import Earnings from 'app/components/Earn/Earnings'
import FAQ from 'app/components/Earn/FAQ'
import Stake from 'app/components/Earn/Stake'
import Unstake from 'app/components/Earn/Unstake'
import LoadingOverlay from 'app/components/LoadingOverlay'
import { connectWallet, WalletStatus } from 'app/features/web3/web3Slice'
import { useAppDispatch, useAppSelector } from 'app/hooks/hooks'
import useMount from 'app/hooks/useMount'
import { RootState } from 'app/store'

import { getInitialStakingData, Status } from './earnSlice'

const Earn: React.FC = () => {
  const { web3, walletStatus } = useAppSelector(
    (state: RootState) => state.web3
  )
  const {
    initialStatus,
    earned = 0,
    canGetReward = false,
    timeLeft = 0,
    claimRewardStatus,
    stakedTokens = 0,
    stakedValue = 0,
    apr = 0,
  } = useAppSelector((state: RootState) => state.earn)

  const dispatch = useAppDispatch()
  useMount(() => {
    const getStaking = async () => {
      await dispatch(getInitialStakingData())
    }
    getStaking()
  })

  // useEffect(() => {
  //   if (web3) {
  //     dispatch(getStakingData())
  //   }
  // }, [web3])

  const overlayVisible = initialStatus === Status.loading

  if (overlayVisible) {
    // TODO make this better
    return <LoadingOverlay visible={overlayVisible} />
  }

  const Stats = (
    <section className="text-gray-400 body-font">
      <div className="container px-5 pb-24 mx-auto">
        <div className="flex flex-wrap -m-4 text-center">
          <div className="w-1/2 p-4 text-white sm:w-1/2">
            <div>
              <dt className="text-sm font-medium text-gray-400 truncate">
                Total staked tokens
              </dt>
              <dd className="mt-1 text-3xl font-semibold">3.8B</dd>
            </div>
          </div>
          <div className="w-1/2 p-4 text-white sm:w-1/2">
            <div>
              <dt className="text-sm font-medium text-gray-400 truncate">
                Total staked holders
              </dt>
              <dd className="mt-1 text-3xl font-semibold">50%</dd>
            </div>
          </div>
        </div>
      </div>
    </section>
  )

  // return <button onClick={() => methodDoesNotExist()}>Break the world</button>

  return (
    <>
      <div className="flex flex-col h-full px-5 py-10 mx-auto max-w-7xl px-41 sm:px-6 lg:px-8 bg-ebony-clay-500">
        <div className="flex-auto max-w-3xl min-w-full min-h-full mx-auto md:min-w-3/4 lg:min-w-1/2">
          {/* {Stats} */}
          {walletStatus === WalletStatus.connected ? (
            <div>
              <Earnings
                {...{
                  earned,
                  timeLeft,
                  canGetReward,
                  claimRewardStatus,
                  stakedTokens,
                  stakedValue,
                  apr,
                }}
              />
              <Stake />
              <Unstake />
              <FAQ />
            </div>
          ) : (
            <div className="flex flex-col min-h-full pt-16 pb-12">
              <main className="flex flex-col justify-center flex-grow w-full px-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
                <div className="py-16">
                  <div className="text-center">
                    <h1 className="mt-2 text-4xl font-bold tracking-tight text-gray-600 sm:text-5xl">
                      Bridge your XOPAD and connect your wallet to XODEX network
                      to continue
                    </h1>
                    {/* <p className="mt-2 text-base text-gray-500">
                    Connect your wallet to continue
                  </p> */}
                    <div className="flex-shrink-0 mt-10">
                      <button
                        type="button"
                        className="relative inline-flex items-center px-4 py-2 text-sm text-white border border-transparent rounded-md shadow-sm bg-spring-green-600 hover:bg-spring-green-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-spring-green-600"
                        onClick={() => {
                          dispatch(connectWallet())
                            .unwrap()
                            .then(() => {
                              dispatch(getInitialStakingData())
                            })
                        }}
                      >
                        <span className="font-bold">{'Connect Wallet'}</span>
                      </button>
                    </div>
                  </div>
                </div>
              </main>
            </div>
          )}
        </div>
      </div>
    </>
  )
}

export default Earn
